import { dataRotateAnticlockwiseSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconRotateAnticlockwiseSolid = /*#__PURE__*/createIcon(dataRotateAnticlockwiseSolid)
export default IconRotateAnticlockwiseSolid
